// 261010 Epic 2 / P3e — hiển thị cue Diễn xuất của một shot, CHỈ ĐỌC. Mọi quyết định (cue nào, còn khớp không, dòng nào hiện) ở `actingPolicy.ts`.
// Dùng ở ba thẻ: Đạo diễn (đủ Kích thích / Phản ứng / Trạng thái sau), Quay phim ("máy phục vụ cue nào"), Prompt (khối debug).
import React from 'react';
import type { FilmShot } from '../../types/film';
import type { ActingPlan } from '../../types/filmActing';
import { cueRowsOf, cueServeLines, cueTraceText, resolveShotCues } from './actingPolicy';
import './acting.css';

/** Thẻ Đạo diễn: dòng trace + từng cue với ô Kích thích / Phản ứng / Trạng thái sau / Diễn xuất / Cách nói / Cơ chế tác động. Shot cũ không cue ⇒ không hiện gì. */
export const ShotCueDetail: React.FC<{ shot: Pick<FilmShot, 'actingCueRefs'>; plan: ActingPlan | null | undefined }> = ({ shot, plan }) => {
  const r = resolveShotCues(shot, plan);
  const trace = cueTraceText(shot, plan);
  if (!trace) return null;
  return (
    <div data-testid="wf-cue-detail">
      <div className={`wf-cue-trace${r.state === 'OK' ? '' : ' warn'}`} role={r.state === 'OK' ? undefined : 'status'}>{trace}</div>
      {r.cues.map((c) => (
        <div key={c.id} className="wf-cue" data-testid={`wf-cue-${c.id}`}>
          <span className="id">{c.id}</span>
          {cueRowsOf(c).map((row) => <div key={row.key} className="row"><span className="l">{row.label}</span><span>{row.text}</span></div>)}
        </div>
      ))}
    </div>
  );
};

/** Thẻ Quay phim: chỉ đọc, "máy phục vụ cue nào". Không control sửa. */
export const ShotCueServe: React.FC<{ shot: Pick<FilmShot, 'actingCueRefs'>; plan: ActingPlan | null | undefined }> = ({ shot, plan }) => {
  const lines = cueServeLines(shot, plan);
  const trace = cueTraceText(shot, plan);
  if (!trace) return null;
  const r = resolveShotCues(shot, plan);
  return (
    <div className="wf-cue-trace" data-testid="wf-cue-serve">
      <span>Máy phục vụ cue: </span>
      {lines.length ? <b>{lines.join(' · ')}</b> : <b>{(shot.actingCueRefs?.cueIds ?? []).join(', ')}</b>}
      {r.state !== 'OK' && <span className="warn"> — {r.state === 'STALE' ? 'Diễn xuất đã đổi sau khi dựng shot này' : 'có cue không còn trong Diễn xuất'}</span>}
    </div>
  );
};
